export default __webpack_public_path__ + "static/media/playstore.0fcd3efe.svg";